module.exports = __webpack_public_path__ + "static/media/maca_cortada.9ad60bdd.png";